ACC.datePicker = {
  dateFormatClass: '.ph-dateFormat',
  setDatePickerLanguage: function() {
    var currLang = $('html').attr('lang'),
        dateFormatValue = $.trim($(ACC.datePicker.dateFormatClass).text()),
        monthArray = [
          'january',
          'february',
          'march',
          'april',
          'may',
          'june',
          'july',
          'august',
          'september',
          'october',
          'november',
          'december'
        ],
        dayArray = [
          'sunday',
          'monday',
          'tuesday',
          'wednesday',
          'thursday',
          'friday',
          'saturday'
        ],
        monthNames = [],
        monthNamesShort = [],
        dayNames = [],
        dayNamesShort = [],
        dayNamesMin = [],
        prevText = 'Prev',
        nextText = 'Next',
        closeText = 'Close',
        currentText = 'Today',
        weekHeader = 'Wk';

    if (dateFormatValue) {
      dateFormatValue = dateFormatValue.replace('yyyy', 'yy');
    } else {
      dateFormatValue = 'dd/MM/yy';
    }

    $.each(monthArray, function(k, v) {
      if ($('.ph-' + v).length > 0) {
        monthNames.push($('.ph-' + v).html());
        monthNamesShort.push($('.ph-' + v.substring(0, 3)).html());
      } else if ($('.ph-months').length > 0) {
        var $newMonth = $('.ph-months');

        monthNames.push($newMonth.attr('data-' + v));
        monthNamesShort.push($newMonth.attr('data-' + v.substring(0, 3)));
      } else {
        monthNames.push(v);
        monthNamesShort.push(v.substring(0, 3));
      }
    });

    $.each(dayArray, function(k, v) {
      if ($('.ph-' + v).length > 0) {
        dayNames.push($('.ph-' + v).html());
        dayNamesShort.push($('.ph-' + v.substring(0, 3)).html());
        dayNamesMin.push($('.ph-' + v.substring(0, 2)).html());
      } else if ($('.ph-days').length > 0) {
        var $newdays = $('.ph-days');

        dayNames.push($newdays.attr('data-' + v));
        dayNamesShort.push($newdays.attr('data-' + v.substring(0, 3)));
        dayNamesMin.push($newdays.attr('data-' + v.substring(0, 2)));
      } else {
        dayNames.push(v);
        dayNamesShort.push(v.substring(0, 3));
        dayNamesMin.push(v.substring(0, 2));
      }
    });

    if ($('.ph-previous').length > 0) {
      prevText = $('.ph-previous').html();
      nextText = $('.ph-next').html();
    } else if ($('.ph-datepickerButton.ph-button').length > 0) {
      prevText = $('.ph-datepickerButton').attr('data-previous');
      nextText = $('.ph-datepickerButton').attr('data-next');
    }

    if ($('.ph-dpCloseText').length > 0) {
      closeText = $('.ph-dpCloseText').html();
    }

    if ($('.ph-dpCurrentText').length > 0) {
      currentText = $('.ph-dpCurrentText').html();
    }

    if ($('.ph-dpWeekHeader').length > 0) {
      weekHeader = $('.ph-dpWeekHeader').html();
    }

    $.datepicker.regional[currLang] = {
      monthNames: monthNames,
      monthNamesShort: monthNamesShort,
      dayNames: dayNames,
      dayNamesShort: dayNamesShort,
      dayNamesMin: dayNamesMin,
      prevText: prevText,
      nextText: nextText,
      closeText: closeText,
      currentText: currentText,
      weekHeader: weekHeader,
      dateFormat: dateFormatValue.toLowerCase()
    };
    $.datepicker.setDefaults($.datepicker.regional[currLang]);
  },
  datePickerInit: function(element) {
    var dateFormatValue = $(ACC.datePicker.dateFormatClass).text(),
        searchStartEndHint = $('.ph-searchStartEndHint').html(),
        tdDate = new Date();

    if (dateFormatValue) {
      dateFormatValue = dateFormatValue.replace('yyyy', 'yy');
    }

    element.datepicker({
      dateFormat: dateFormatValue.toLowerCase(),
      maxDate: new Date(tdDate.setDate(tdDate.getDate()))
    });
    element.datepicker('option', 'appendText', searchStartEndHint);
  }
};
$(document).ready(function() {
  ACC.datePicker.setDatePickerLanguage();
  $(document).on('click', '.ph-calendaricon', function() {
    $(this).parent().parent().find('input.hasDatepicker').datepicker('show');
  });
});
